import './App.css'
import { ToastContainer } from 'react-toastify';
import Router from './routes/Router';
import 'react-toastify/dist/ReactToastify.css'
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import { AxiosInterceptor } from './services/api';
import { SessionContextProvider } from '@supabase/auth-helpers-react';
import { supabase } from './common/config/supabase';
import * as Sentry from "@sentry/react";
import { UserContextProvider } from './contexts/user/UserContextProvider';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  enabled: import.meta.env.NODE === 'production',
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", 'https://main.dj18mndaveg3r.amplifyapp.com'],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      staleTime: 0,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: 'always',
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <SessionContextProvider supabaseClient={supabase}>
        <UserContextProvider>
          <AxiosInterceptor>
            <>
              <ToastContainer
                position={'top-right'}
                autoClose={30000}
                limit={3}
                closeOnClick
                rtl={false}
              />

              <Router />
            </>
          </AxiosInterceptor>
        </UserContextProvider>
      </SessionContextProvider>
    </QueryClientProvider>
  )
}

export default App
